/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react"

import { NavMain, NavSecondary } from "../Nav"

/**
 * Footer Navigation Content
 * @param {object} - props - react props
 * @param {object} - props.style - parent component CSS Module Style object
 * @param {object} - props.children - child react components
 */
const FooterNav = ({ style, children }) => {
  return (
    <nav className={style.footerNav}>
      <NavMain
        analytics="FOOTER"
        className={style.main}
        linkStyleMap={{
          exo: style.exo,
          vis: style.vis,
          tech: style.tech
        }}
      />
      <NavSecondary analytics="FOOTER" className={style.secondary} />
      <div className={style.socialFooterWrapper}>{children}</div>
    </nav>
  )
}

export default FooterNav
